/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
// import CustomAlert from 'components/alerts/CustomAlert';
import Avatar from 'components/base/Avatar';
import Button from 'components/base/Button';
import PageLoader from 'components/custom/animate-component/PageLoader';
import LabelSelector from 'components/custom/forms/LabelSelector';
import Selector from 'components/custom/forms/Selector';
import Icon from 'components/icon';
import apiEndpoints from 'constants/apiEndpoints';
import { useFormik } from 'formik';
import useFetchData from 'hooks/custom/useFetchData';
import { useAlert } from 'providers/AlertModalProvider';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
// import postData from 'services/postData';
import fetchData from 'services/fetchData';
import postData from 'services/postData';
import * as Yup from 'yup';
import { findIndividual, formatDate } from 'services/utils';
import LabelInput from 'components/custom/forms/LabelInput';
import useShowModal from 'hooks/custom/useShowModal';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    /* max-width: 300px !important; */
    margin-right: auto;

    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

const EditQuickTrucker = ({
  show,
  handleClose,
  data,
  handleRefresh,
  // updateSuccessfully,
  setIsManualUpdate,
  refreshData,
  setId
}) => {
  const [loading, setLoading] = useState(false);
  const [DriverList, setDriverList] = useState([]);
  const { showAlert } = useAlert();

  const formik = useFormik({
    initialValues: {
      // trucker_contact_person_phone: data?.trucker_contact_person_phone,
      trucker_id: data?.trucker_id,
      trucker_name: data?.trucker_name,
      trucker_contact_person_name: data?.trucker_contact_person_name,
      trucker_phone: data?.trucker_phone,
      trucker_address: data?.trucker_address,
      pan_no: data?.pan_no,
      gst_no: data?.gst_no || '',
      trucker_account_holder_name: data?.trucker_account_holder_name,
      trucker_bank_name: data?.trucker_bank_name,
      trucker_account_number: data?.trucker_account_number,
      trucker_bank_ifsc: data?.trucker_bank_ifsc,
      // trucker_rate: data?.trucker_rate || ''
    },
    validationSchema: Yup.object({
      trucker_contact_person_phone: Yup.string(),
      // trucker_id: Yup.string(),
      trucker_name: Yup.string().required('Trucker Name is required'),
      trucker_contact_person_name: Yup.string().required(
        'Contact Name is required'
      ),
      trucker_phone: Yup.number().required('Trucker Phone is required'),
      trucker_address: Yup.string().required('Trucker Address is required'),
      pan_no: Yup.string().required('PAN Number is required'),
      // gst_no: Yup.string().matches(
      //   /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9][A-Z0-9]$/,
      //   'Invalid GST Number format'
      // ),
      gst_no: Yup.string().matches(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9][A-Z][0-9A-Z]$/,
        'Invalid GST Number format'
      ),

      // .required('GST Number is required'),
      trucker_account_holder_name: Yup.string().required(
        'Account Holder Name is required'
      ),
      trucker_bank_name: Yup.string().required('Trucker Bank Name is required'),
      trucker_account_number: Yup.string().required(
        'Account Number is required'
      ),
      trucker_rate: Yup.string(),
      // .required('Trucker Rate is required'),
      trucker_bank_ifsc: Yup.string().required('Bank IFSC is required'),

      trucker_id: Yup.number()
    }),
    onSubmit: async values => {
      setLoading(true);
      try {
        const response = await postData(
          values,
          apiEndpoints.trucker.EditQuickTrucker
        );
        if (response?.status) {
          showAlert({
            variant: 'success',
            message: 'The Trucker has been Updated successfully.'
          });
          // setId(response.data?.trucker_detail?.trucker_id);
          handleRefresh();
          setIsManualUpdate(true);
          // updateSuccessfully(true)
          handleClose();
        } else {
          let errorObj = response.errors;
          if (errorObj) {
            formik.setErrors(
              Object.keys(response.errors)?.reduce(
                (acc, er) => ({ ...acc, [er]: errorObj[er][0] }),
                {}
              )
            );
          }
          showAlert({
            variant: 'danger',
            message: 'Failed to Update Trucker.'
          });
        }
      } catch (error) {
        showAlert({
          variant: 'danger',
          message: 'An unexpected error occurred. Please try again.'
        });
      } finally {
        setLoading(false);
      }
    }
  });
  console.log(formik.errors, 'madhu333');
  return (
    <>
      {/* <Form onSubmit={formik.handleSubmit}> */}
      <CustomModal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="medium"
        centered
      >
        <Modal.Header
          className="border-0 position-relative pb-0 end-0 dark__text-white"
          closeButton={!loading}
        >
          <div className="d-flex align-items-center mb-2">
            <Avatar size="xl" variant="name" className="me-2">
              <Icon icon={'icon-park-outline:add-user'} fontSize="18px" />
            </Avatar>
            Edit Trucker
            {/* main file*/}
          </div>
        </Modal.Header>

        <Modal.Body className="pt-2 position-relative">
          <Row className="">
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'Trucker Name'}
                errorProps={{ tooltip: false }}
                controlId={'trucker_name'}
                required={true}
                formik={formik}
              />
            </Col>
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'Contact Name'}
                errorProps={{ tooltip: false }}
                controlId={'trucker_contact_person_name'}
                required={true}
                formik={formik}
              />
            </Col>
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'Contact Number'}
                inputProps={{ type: 'number' }}
                errorProps={{ tooltip: false }}
                controlId={'trucker_phone'}
                required={true}
                formik={formik}
              />
            </Col>
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'Address'}
                // inputProps={{ readOnly: true }}
                errorProps={{ tooltip: false }}
                controlId={'trucker_address'}
                required={true}
                formik={formik}
              />
            </Col>

            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                errorProps={{ tooltip: false }}
                controlId={'pan_no'}
                required
                // inputProps={{ type: 'number' }}
                label={'PAN No'}
                formik={formik}
                inputProps={{ placeholder: 'AAAAA0000A' }}
                formatter={'AAAAA0000A'}
              />
            </Col>
            {/* <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'Aadhar No.'}
                // inputProps={{ readOnly: true }}
                errorProps={{ tooltip: false }}
                controlId={'aadhar'}
                required={false}
                formik={formik}
              />
            </Col> */}

            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                errorProps={{ tooltip: false }}
                controlId={'gst_no'}
                label={'GST No'}
                // required
                formik={formik}
                inputProps={{ placeholder: '00AAAAA0000A0AX' }}
                formatter={'00AAAAA0000A0AX'}
              />
            </Col>

            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                errorProps={{ tooltip: false }}
                controlId={'trucker_bank_ifsc'}
                label={'IFSC'}
                required
                formik={formik}
              />
            </Col>
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                errorProps={{ tooltip: false }}
                controlId={'trucker_bank_name'}
                label={'Bank Name'}
                required
                formik={formik}
              />
            </Col>
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                errorProps={{ tooltip: false }}
                controlId={'trucker_account_holder_name'}
                required
                label={'Account Holder'}
                formik={formik}
              />
            </Col>
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                errorProps={{ tooltip: false }}
                required
                controlId={'trucker_account_number'}
                label={'Account Number'}
                formik={formik}
              />
            </Col>
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                errorProps={{ tooltip: false }}
                // required
                controlId={'trucker_rate'}
                label={'Trucker Rate'}
                formik={formik}
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="phoenix-secondary"
            disabled={loading}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="phoenix-success"
            onClick={formik.handleSubmit}
            disabled={loading}
          >
            Submit
          </Button>
        </Modal.Footer>
      </CustomModal>
      {/* </Form> */}
      <PageLoader loading={loading} loadingMessage={'Creating Trucker'} />
    </>
  );
};

export default EditQuickTrucker;
